import { User, Worker } from 'model'
import {
  IPersonaProps,
  Persona,
  PersonaInitialsColor,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useReadUserQuery, useReadWorkerQuery } from './UserPersona.generated'

export type UserPersonaProps = IPersonaProps & {
  // person?:
  person?: User | Worker
}

export type UserPersonaByIdProps = IPersonaProps & {
  personId: string
}

export const UserPersona: React.FunctionComponent<UserPersonaProps> = ({
  person,
  ...props
}) =>
  person ? (
    <Persona
      text={person.name}
      initialsColor={PersonaInitialsColor.lightRed}
      secondaryText={
        person.__typename === 'User'
          ? person.email || ''
          : person.department || ''
      }
      tertiaryText={
        person.__typename === 'User'
          ? person.department
            ? person.department
            : ''
          : ''
      }
      {...props}
    />
  ) : null

export const UserPersonaById: React.FunctionComponent<UserPersonaByIdProps> = ({
  personId,
  ...props
}) => {
  const { data } = useReadUserQuery({
    variables: {
      id: personId,
    },
  })

  const workerData = useReadWorkerQuery({
    variables: {
      id: personId,
    },
  })

  const person = data && data.dbUser ? data.dbUser : undefined
  const worker =
    workerData && workerData.data && workerData.data.worker
      ? workerData.data.worker
      : undefined

  return person ? (
    <Persona
      text={person.name}
      initialsColor={PersonaInitialsColor.lightRed}
      secondaryText={
        person.__typename === 'User'
          ? person.email || ''
          : person.department || ''
      }
      tertiaryText={
        person.__typename === 'User'
          ? person.department
            ? person.department
            : ''
          : ''
      }
      {...props}
    />
  ) : worker ? (
    <Persona
      text={`${worker.lastName}, ${worker.firstName}`}
      initialsColor={PersonaInitialsColor.lightRed}
      secondaryText={worker.department || ''}
      {...props}
    />
  ) : null
}

export default UserPersona
